"use strict";

function EditPostDirective(
  $stateParams,
  config,
  growl,
  $sce,
  $translate) {
  return {
    restrict: 'A',
    scope: {
      post: '=',
      allowEdit: '='

    },
    link: function(scope) {
      scope.oldPost = angular.copy(scope.post);
      scope.updatePost = function() {
        if (!scope.allowEdit) {
          return;
        }
        scope.post.$updatePost({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          postId: scope.post.id
        }, function(){
          growl.addSuccessMessage($translate.instant('publication.save-success'));
          scope.showFormEditPost = false;
        }, function(){
          growl.addErrorMessage($translate.instant('publication.save-failure'));
        });
      };

      scope.trustAsHtml = function(string) {
        return $sce.trustAsHtml(string);
      };
    },
    templateUrl: 'partials/company/publications/detail/edit-blog.html'
  };
}

angular.module('dokiv')
  .directive('toggleEditPost', [
    '$stateParams',
    'config',
    'growl',
    '$sce',
    '$translate',
    EditPostDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/blogs/EditPostDirective.js
// module id = 395
// module chunks = 0